import { supportedLocales } from "@/i18n";
import { HttpStatusCode } from "axios";
import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().nonempty(),
  locale: z.enum(supportedLocales),
});

export type LoginDTO = z.infer<typeof loginSchema>;

export type LoginResponseDTO =
  | {
      message: string;
    }
  | {
      token: string;
      deviceId?: string;
      lastUsedIp?: string;
      twoFactorLastUsedAt?: string;
    };

/** Code renvoyé par /auth/signin (403) pour un compte `customer` du site public. */
export const NO_BACKOFFICE_ACCESS_CODE = "AUTH_NO_BACKOFFICE_ACCESS";

export type LoginResponse =
  | {
      status: Exclude<HttpStatusCode, HttpStatusCode.Ok>;
      message: string;
      code?: string;
    }
  | {
      status: HttpStatusCode.Ok;
      token: string;
      deviceId?: string;
      lastUsedIp?: string;
      twoFactorLastUsedAt?: string;
    };

export const twoFactorAuthSchema = z.object({
  email: z.string().email(),
  twoFactorToken: z.string().length(6),
  locale: z.enum(supportedLocales),
});

export type TwoFactorAuthDTO = z.infer<typeof twoFactorAuthSchema>;

export type UpdateUserDTO = Partial<{
  name: string;
  lastName: string;
  email: string;
  phone: string;
}>;
